import React, { useEffect, useState } from 'react';
import { exchangeCodeForTokens } from '../../config/auth';
import { auth } from '../../services/api';

const AuthCallback: React.FC = () => {
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const handleCallback = async () => {
      if (auth.isAuthenticated()) {
        window.location.href = '/';
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const errorParam = params.get('error');

      if (errorParam) {
        if (!cancelled) setError(true);
        return;
      }

      if (!code) {
        if (!cancelled) setError(true);
        return;
      }

      try {
        const tokens = await exchangeCodeForTokens(code);
        if (cancelled) return;
        auth.setToken(tokens.id_token);
        localStorage.setItem('accessToken', tokens.access_token);
        if (tokens.refresh_token) {
          localStorage.setItem('refreshToken', tokens.refresh_token);
        }
        window.location.href = '/';
      } catch (err) {
        if (cancelled) return;
        if (auth.isAuthenticated()) {
          window.location.href = '/';
          return;
        }
        console.error('Auth callback failed:', err);
        setError(true);
      }
    };

    handleCallback();
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: 'Inter, system-ui, sans-serif'
      }}>
        <img
          src="/joule-logo.png"
          alt="Joule"
          style={{ height: '2.5rem', marginBottom: '2rem' }}
        />
        <div style={{
          backgroundColor: 'white',
          padding: '3rem',
          borderRadius: '0.5rem',
          boxShadow: '0 0.125rem 0.5rem rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '28rem'
        }}>
          <h2 style={{ margin: '0 0 1rem 0', color: '#333', fontSize: '1.25rem' }}>
            Authentication Failed
          </h2>
          <p style={{ color: '#666', marginBottom: '2rem', fontSize: '0.875rem', lineHeight: '1.5' }}>
            We were unable to verify your identity. Please try again or contact your administrator if the issue persists.
          </p>
          <button
            onClick={() => { window.location.href = '/'; }}
            style={{
              backgroundColor: '#1a1a2e',
              color: 'white',
              border: 'none',
              padding: '0.625rem 1.5rem',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              fontSize: '0.875rem'
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <img
        src="/joule-logo.png"
        alt="Joule"
        style={{ height: '2.5rem', marginBottom: '2rem' }}
      />
      <p style={{ color: '#666', fontSize: '0.875rem' }}>Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
